import { useEffect, useReducer, useRef } from "react";
import axios from "axios";

import { BASE_URL } from "../services/api";

const initialState = {
	loading: true,
	error: "",
	data: {},
};

const reducer = (state, action) => {
	switch (action.type) {
		case "FETCH_START":
			return {
				...state,
				loading: true,
				error: "",
			};
		case "FETCH_SUCCESS":
			return {
				loading: false,
				data: action.payload,
				error: "",
			};
		case "FETCH_ERROR":
			return {
				loading: false,
				data: {},
				error: "Something went Wrong",
			};
		default:
			return state;
	}
};

export function useGetWithRefresh(endpoint, access_token, refreshTrigger = 0) {
	const [state, dispatch] = useReducer(reducer, initialState);
	const isMountedRef = useIsMountedRef();

	useEffect(() => {
		const fetchData = async () => {			
			// Dispatch loading state
			dispatch({ type: "FETCH_START" });
			
			try {
				const response = await axios.get(`${BASE_URL}/${endpoint}`, {
					headers: {
						Authorization: `Bearer ${access_token}`,
					},
				});
				
				if (isMountedRef.current) {
					dispatch({
						type: "FETCH_SUCCESS",
						payload: response.data,
					});
				}
			} catch (error) {
				if (isMountedRef.current) {
					dispatch({ type: "FETCH_ERROR" });
				}
			}
		};
		
		if (endpoint && access_token) {
			fetchData();
		}
	}, [access_token, endpoint, refreshTrigger, isMountedRef]);

	return { state };
}

// https://www.debuggr.io/react-update-unmounted-component/
function useIsMountedRef() {
	const isMountedRef = useRef(null);
	useEffect(() => {
		isMountedRef.current = true;
		return () => (isMountedRef.current = false);
	});
	return isMountedRef;
}
